import React, { Component, PropTypes } from 'react';
import { connect } from 'react-redux';
import HeaderStyles from './Styles';
import HeaderIcon from './Icon';
import HeaderGeneral from './General';
import HeaderPreview from './Preview';
import Draggable from 'react-draggable';
import { SparkTabs } from '../../../ui/spark';
import LogoStyles from './LogoStyles';
import PageTitleFaviconStyles from './PageTitleFaviconStyles';
import TabletPreview from './TabletPreview';
import MobilePreview from './MobilePreview';
import HamburgerStyles from './HamburgerStyles';
import HeroImageStyles from './HeroImageStyles';
import store from '../../../../store/Store';
import { Service as FileService } from '../../../../services/Service';
import ReactSparkTextInput from '../../../widgets/ReactSparkTextInput';
import { PresetColorPicker } from '../../../widgets/index';
import { CATEGORIES } from '../../../../services/fileUpload/uploadFile';
import { onCssLengthChange, onThemePropChange, parseUrlProperty } from '../../../helpers/ThemeStoreHelpers';
import ModalAssetBrowser from '../../../widgets/ModalAssetBrowser';
import { checkPermissionForLevel, checkPermissions } from '../../../../../lib/utils';
import { ACCESS_POINTS_GROUP, ACCESS_POINT_LEVEL } from '../../../../constants/AccessPoints';

class ThemeHeader extends Component {
    render() {
        return (
            <div className="ThemeHeader Theme-Content spark-panel__content">
                <h1>Header</h1>
                <div className="subpages-main-content row">{this.headerDesktop()}</div>
            </div>
        );
    }

    headerDesktop() {
        return (
            <div className="col-xs-12">
                <div className="spark-panel spark-mar-t-1 spark-panel-buttons row">
                    <div className="spark-panel__content col-xs-12">
                        <h4>Desktop</h4>
                        <HeaderPreview
                            preview={this.props}
                            userBar={this.props.userBar}
                            isDisabled={!this.props.hasAccessThemesEdit}
                        />
                        <h4>Tablet</h4>
                        <div className="col-xs-9">
                            <TabletPreview
                                preview={this.props}
                                userBar={this.props.userBar}
                                isDisabled={!this.props.hasAccessThemesEdit}
                            />
                        </div>
                        <h4>Mobile</h4>
                        <div className="col-xs-6">
                            <MobilePreview
                                preview={this.props}
                                userBar={this.props.userBar}
                                isDisabled={!this.props.hasAccessThemesEdit}
                            />
                        </div>
                        <br />
                        <div className="row">
                            <div className="col-xs-5">
                                <HeaderStyles
                                    id="theme-text-heading"
                                    tagNameName="Primary Text"
                                    tagName="primaryText"
                                    sampleText="Primary Text"
                                    fontData={this.props.primaryText}
                                    userBar={this.props.userBar}
                                    isDisabled={!this.props.hasAccessThemesEdit}
                                />
                            </div>
                            <div className="col-xs-1" />
                            <div className="col-xs-6">
                                <div className="row">
                                    <div className="col-xs-6">
                                        <HeaderIcon
                                            id="theme-text-icon"
                                            tagNameName="Icon"
                                            tagName="icon"
                                            sampleText="Icon"
                                            fontData={this.props.icon}
                                            userBar={this.props.userBar}
                                            isDisabled={!this.props.hasAccessThemesEdit}
                                        />
                                    </div>
                                    <div className="col-xs-6">
                                        <HeaderGeneral
                                            id="theme-background-color"
                                            tagNameName="Background Color"
                                            tagName="general"
                                            sampleText="Background Color"
                                            fontData={this.props.general}
                                            userBar={this.props.userBar}
                                            isDisabled={!this.props.hasAccessThemesEdit}
                                        />
                                    </div>
                                </div>
                                <div className="row">
                                    <div className="col-xs-12">
                                        <HamburgerStyles
                                            id=""
                                            tagNameName="Hamburger Menu"
                                            tagName="subtitle"
                                            platform="tablet"
                                            hamburgerMenu={this.props.hamburgerMenu}
                                            isDisabled={!this.props.hasAccessThemesEdit}
                                        />
                                    </div>
                                </div>
                            </div>
                            <div className="col-xs-5">
                                <LogoStyles isDisabled={!this.props.hasAccessThemesEdit} />
                            </div>
                        </div>
                    </div>
                    <div className="row col-lg-12">
                        <div className="spark-panel__content col-xs-5">
                            <PageTitleFaviconStyles isDisabled={!this.props.hasAccessThemesEdit} />
                        </div>
                    </div>
                    <div className="row col-lg-12">
                        <div className="spark-panel__content col-xs-5">
                            <HeroImageStyles isDisabled={!this.props.hasAccessThemesEdit} />
                        </div>
                    </div>
                    <div className="row col-lg-12">
                        <div className="spark-panel__content">
                            <h5 className="col-xs-12 col-sm-3">Landing Image</h5>
                            <div className="col-xs-12 col-sm-3 col-lg-11 top-margin">
                                <ReactSparkTextInput
                                    label="Landing Image URL"
                                    isDisabled={!this.props.hasAccessThemesEdit}
                                    value={parseUrlProperty(this.props.landingPage.background.image)}
                                    onChange={e => {
                                        e.target.value
                                            ? this.props.onThemePropChange('image')(`url(${e.target.value})`)
                                            : this.props.onThemePropChange('image')('');
                                    }}
                                />
                            </div>
                            <div className="col=lg=1 col-xs-1 col-sm-1 top-margin">
                                <ModalAssetBrowser
                                    category={CATEGORIES.IMAGE}
                                    isDisabled={!this.props.hasAccessThemesEdit}
                                    store={store}
                                    onSelect={assets => {
                                        if (assets.length >= 1) {
                                            let asset = assets[0];
                                            this.props.onThemePropChange('image')(
                                                `url(${FileService.assetUrl(
                                                    asset.chainid,
                                                    asset.hotelid,
                                                    null,
                                                    this.props.level,
                                                    asset.filename,
                                                    false,
                                                    CATEGORIES.IMAGE
                                                )})`
                                            );
                                        }
                                    }}
                                />
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        );
    }
}

ThemeHeader.propTypes = {
    children: PropTypes.element
};

const mapThemeHeaderStateToProps = state => ({
    ...state.app.data.theme.header,
    ...state.theme.header,
    userBar: state.app.data.theme.header.userBar,
    hamburgerMenu: state.app.data.theme.header.hamburgerMenu,
    level: state.app.selected.level,
    hasAccessThemesEdit: checkPermissionForLevel(
        state.oauth.accessLevel,
        ACCESS_POINTS_GROUP.THEMES,
        ACCESS_POINT_LEVEL.EDIT,
        state.oauth.userPermissionLevels,
        state.app.selected.level
    )
});

const mapHeaderStylesDispatchToProps = dispatch => ({
    onThemePropChange: onThemePropChange(dispatch, 'header.landingPage.background')
});

export default connect(mapThemeHeaderStateToProps, mapHeaderStylesDispatchToProps)(ThemeHeader);



// WEBPACK FOOTER //
// ./src/components/pages/theme/header/index.js